import React from "react";

import { withAuth } from "./containers/containerAuth";

import DropDown from "./items/contols/dropDown";
import UserStateDropDownMenu from "./userStateDropDownMenu";

import styles from "./userState.module.scss";

const UserState = (props) => {
  const { data } = props;

  return (
    <div className={styles.userState}>
      <div className={styles.userImage}>
        <span className="icon-user"></span>
      </div>

      <div className={styles.container_userStateData}>
        <DropDown
          button={
            <div>
              <span className={styles.userName}>{data.companyTitle}</span>
              <span>{data.userTitle}</span>
            </div>
          }
          content={<UserStateDropDownMenu />}
        />
      </div>
    </div>
  );
};

export default withAuth(React.memo(UserState));
